import React from "react";
import {connect} from "react-redux";
import {Tab, Tabs} from "react-bootstrap";
import {traerPalabrasTabla} from "../../_actions";
import {buscadorConstants} from "../../_constants";
import MiTabla from "../../_helpers/MiTabla";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import authService from "../../_services/cart/authService";
import {history, prepareDataSearch} from "../../_helpers";
import http from "../../_services/cart/http.service";
import alertService from "../../_services/cart/alert.service";
import {NavBarLateral} from "../includes";
import {FormEditarTipo} from "./utils/FormEditarTipo";
import Select from "react-select";

const tableRefMarca = React.createRef();
const tableRefModelo = React.createRef();
const tableRefVersion = React.createRef();

const bagRef = React.createRef();
const _ = require("lodash");

class MarcaTiposList extends React.Component {
    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(buscadorConstants.infoTablaDefault);
    }

    state = {
        tipoKey: "MARCA",
        loading: false,
        objeto: {},
        showEdit: false,
        marca: {id: undefined},
        modelo: {id: undefined}
    };

    componentDidMount() {
    }

    buscarMisModelos = (modelos, marcaId) => {
        let finalModelos = [];

        if (marcaId === undefined) {
            return finalModelos;
        }

        finalModelos = modelos?.filter((it) => it.marca.id === marcaId);

        return finalModelos;
    };

    editar = (objeto, tipo) => {
        this.setState({
            showEdit: true,
            objeto: objeto,
            tipo: tipo,
        });
    };

    actualizar = () => {
        if (this.state.tipoKey == "MARCA" && tableRefMarca.current) {
            tableRefMarca.current.onQueryChange();
            tableRefModelo.current.onQueryChange();
        }

        if (this.state.tipoKey == "MODELO" && tableRefModelo.current) {
            tableRefModelo.current.onQueryChange();
            tableRefVersion.current.onQueryChange();
        }

        if (this.state.tipoKey == "VERSION" && tableRefVersion.current) {
            tableRefVersion.current.onQueryChange();
        }
    };

    actualizarPageSize = (newPageSIze) => {
        if (this.state.tipoKey == "MARCA" && tableRefMarca.current) {
            tableRefMarca.current.dataManager.changePageSize(newPageSIze)
        }

        if (this.state.tipoKey == "MODELO" && tableRefModelo.current) {
            tableRefModelo.current.dataManager.changePageSize(newPageSIze)
        }

        if (this.state.tipoKey == "VERSION" && tableRefVersion.current) {
            tableRefVersion.current.dataManager.changePageSize(newPageSIze)
        }
    };

    handleClose = () => {
        if (this.state.tipoKey == "MARCA" && tableRefMarca.current) {
            tableRefMarca.current.onQueryChange();
            tableRefModelo.current.onQueryChange();
        }

        if (this.state.tipoKey == "MODELO" && tableRefModelo.current) {
            tableRefModelo.current.onQueryChange();
            tableRefVersion.current.onQueryChange();
        }

        if (this.state.tipoKey == "VERSION" && tableRefVersion.current) {
            tableRefVersion.current.onQueryChange();
        }

        this.setState({
            showEdit: false,
            objeto: undefined,
            nuevaBusqueda: true,
        });
    };

    buscarData = (query) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            http
                .post(
                    "/api/admin/tipos/MARCA",
                    prepareDataSearch(query, "nombre", "ASC", this.state.values)
                )
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    buscarDataModelo = (query) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;

            http
                .post(
                    "/api/admin/tipos/MODELO",
                    prepareDataSearch(query, "nombre", "ASC", this.state.values)
                )
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});

                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });

                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    buscarDataVersion = (query) => {
        return new Promise((resolve, reject) => {
            if (this.state.nuevaBusqueda) query.page = 0;
            let values = {
                marca: this.state.marca?.id,
                modelo: this.state.modelo?.id
            }

            http
                .post(
                    "/api/admin/tipos/VERSION",
                    prepareDataSearch(query, "nombre", "ASC", values)
                )
                .then(
                    (data) => {
                        this.setState({nuevaBusqueda: false});
                        resolve({
                            data: data.content ? data.content : [],
                            page: query.page,
                            totalCount: data ? data.totalElements : 0,
                        });
                        this.actualizarPageSize(query.pageSize);
                    },
                    (error) => {
                        alertService.error(error);
                    }
                );
        });
    };

    render() {
        if (!authService.hasAuthority("ADMIN")) {
            history.push("/");
        }

        const {loading} = this.state;
        const {filtros} = this.props;

        const headerMarca = [
            {title: "ID", field: "id"},
            {title: "Nombre", field: "nombre"},
            {
                title: "Activo",
                field: "active",
                render: (row) => <span>{row.active ? "Si" : "No"}</span>,
            },
            {
                title: "",
                cellStyle: {textAlign: "center"},
                render: (row) => (
                    <div
                        className="table-button"
                        onClick={() => this.editar(row, "MARCA")}
                    >
                        <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                         icon="fa-solid fa-pencil"></FontAwesomeIcon>
                    </div>
                ),
            },
        ];

        const headerModelo = [
            {title: "ID", field: "id"},
            {title: "Nombre", field: "nombre"},
            {title: "Marca", field: "marca.nombre"},
            {
                title: "Activo",
                field: "active",
                render: (row) => <span>{row.active ? "Si" : "No"}</span>,
            },
            {
                title: "",
                cellStyle: {textAlign: "center"},
                render: (row) => (
                    <div
                        className="table-button"
                        onClick={() => this.editar(row, "MODELO")}
                    >
                        <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                         icon="fa-solid fa-pencil"></FontAwesomeIcon>
                    </div>
                ),
            },
        ];

        const headerVersion = [
            {title: "ID", field: "id"},
            {title: "Nombre", field: "nombre"},
            {title: "Marca", field: "modelo.marca.nombre"},
            {title: "Modelo", field: "modelo.nombre"},
            {
                title: "Activo",
                field: "active",
                render: (row) => <span>{row.active ? "Si" : "No"}</span>,
            },
            {
                title: "",
                cellStyle: {textAlign: "center"},
                render: (row) => (
                    <div
                        className="table-button"
                        onClick={() => this.editar(row, "VERSION")}
                    >
                        <FontAwesomeIcon className={'button'} data-type={'complementary-smallest'}
                                         icon="fa-solid fa-pencil"></FontAwesomeIcon>
                    </div>
                ),
            },
        ];

        const customSelect = {
            control: (provided) => ({ // class attribute : class=" css-i32vvf-control"
                ...provided,
                background: 'transparent',
                borderColor: 'transparent',
                height: '58px',
            }),
        };

        const options = {
            search: true,
            sorting: true,
            fontSize: 6,
            filtering: false,
            selection: false,
            //pageSize: this.state.nuevo.limit,
            pageSizeOptions: [5, 10, 25, 30, 50, 75, 100],
            exportAllData: true,
            overflowX: "auto",
            tableLayout: "auto",
        };

        return (
            <>
                <div className="dashboard">
                    <NavBarLateral handleClose={this.handleClose}/>
                    <div className="dashboard__content">
                        <div className="dashboard__content-header">
                            <div className="dashboard__content-title">
                                <h2>Tipos</h2>
                            </div>
                        </div>

                        <Tabs
                            id="controlled-tab-example"
                            activeKey={this.state.tipoKey}
                            onSelect={(k) => this.setState({tipoKey: k})}
                        >
                            <Tab eventKey="MARCA" title="Marca">
                                <button
                                    type="button"
                                    className="button"
                                    data-type="primary"
                                    onClick={() => this.editar(undefined, "MARCA")}
                                >
                                    Nueva Marca
                                </button>
                                <div className="dashboard__content-main--tab">
                                    <MiTabla
                                        title=""
                                        tableRef={tableRefMarca}
                                        columns={headerMarca}
                                        options={options}
                                        style={{
                                            tableLayout: "auto",
                                            width: "100%",
                                            maxWidth: "100%",
                                            height: "auto",
                                            borderRadius: "1rem",
                                            border: "1px solid #d2d2d2",
                                            boxShadow: "none",
                                            backgroundColor: 'inherit',
                                            color: 'inherit'
                                        }}
                                        data={(query) => this.buscarData(query, false)}
                                        localization={traerPalabrasTabla("Marca")}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="MODELO" title="Modelo">
                                <button
                                    type="button"
                                    className="button"
                                    data-type="primary"
                                    onClick={() => this.editar(undefined, "MODELO")}
                                >
                                    Nueva Modelo
                                </button>

                                <div className="dashboard__content-main--tab">
                                    <MiTabla
                                        title=""
                                        tableRef={tableRefModelo}
                                        columns={headerModelo}
                                        options={options}
                                        style={{
                                            tableLayout: "auto",
                                            width: "100%",
                                            maxWidth: "100%",
                                            height: "auto",
                                            borderRadius: "1rem",
                                            border: "1px solid #d2d2d2",
                                            boxShadow: "none",
                                            backgroundColor: 'inherit',
                                            color: 'inherit'
                                        }}
                                        data={(query) => this.buscarDataModelo(query, false)}
                                        localization={traerPalabrasTabla("Modelo")}
                                    />
                                </div>
                            </Tab>
                            <Tab eventKey="VERSION" title="Versión">
                                <button
                                    type="button"
                                    className="button"
                                    data-type="primary"
                                    onClick={() => this.editar(undefined, "VERSION")}
                                >
                                    Nueva Versión
                                </button>

                                <div>
                                    <Select
                                        className="sideBar-select"
                                        cacheOptions
                                        defaultOptions
                                        isClearable={true}
                                        value={
                                            filtros?.marcas
                                                ? filtros?.marcas.find(
                                                    (option) => option.id === this.state.marca?.id
                                                )
                                                : ""
                                        }
                                        placeholder="Marca"
                                        getOptionLabel={(option) => `${option.nombre}`}
                                        getOptionValue={(option) => option.id}
                                        options={filtros?.marcas}
                                        onChange={(opt) => {
                                            this.setState({"marca": opt}, this.actualizar);

                                        }}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        styles={customSelect}
                                    />

                                    {/* <Form.Label>Modelo</Form.Label> */}
                                    <Select
                                        className="sideBar-select"
                                        cacheOptions
                                        defaultOptions
                                        disabled={this.state.marca === undefined}
                                        value={
                                            filtros?.modelos
                                                ? filtros?.modelos.find(
                                                    (option) => option.id === this.state.modelo?.id
                                                )
                                                : ""
                                        }
                                        placeholder="Modelo"
                                        isClearable={true}
                                        getOptionLabel={(option) => `${option.nombre}`}
                                        getOptionValue={(option) => option.id}
                                        options={this.buscarMisModelos(filtros?.modelos, this.state.marca?.id)}
                                        onChange={(opt) => {
                                            this.setState({"modelo": opt}, this.actualizar);

                                        }}
                                        components={{
                                            IndicatorSeparator: () => null
                                        }}
                                        styles={customSelect}
                                    />
                                </div>
                                <div className="dashboard__content-main--tab">
                                    <MiTabla
                                        title=""
                                        tableRef={tableRefVersion}
                                        columns={headerVersion}
                                        options={options}
                                        style={{
                                            tableLayout: "auto",
                                            width: "100%",
                                            maxWidth: "100%",
                                            height: "auto",
                                            borderRadius: "1rem",
                                            border: "1px solid #d2d2d2",
                                            boxShadow: "none",
                                            backgroundColor: 'inherit',
                                            color: 'inherit'
                                        }}
                                        data={(query) => this.buscarDataVersion(query, false)}
                                        localization={traerPalabrasTabla("Version")}
                                    />
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>

                <FormEditarTipo
                    tipo={this.state.tipo}
                    objeto={this.state.objeto}
                    show={this.state.showEdit}
                    handleClose={this.handleClose}
                ></FormEditarTipo>
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {};

const connectedMarcaTiposList = connect(
    mapState,
    actionCreators
)(MarcaTiposList);
export {connectedMarcaTiposList as MarcaTiposList};
